import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=936e5d7a"
import script from "./Filters.vue?vue&type=script&lang=ts"
export * from "./Filters.vue?vue&type=script&lang=ts"
import style0 from "./Filters.vue?vue&type=style&index=0&id=936e5d7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports